import { render, staticRenderFns } from "./Dialog_AddAdvisory.vue?vue&type=template&id=81172b10&scoped=true&"
import script from "./Dialog_AddAdvisory.vue?vue&type=script&lang=js&"
export * from "./Dialog_AddAdvisory.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_AddAdvisory.vue?vue&type=style&index=0&id=81172b10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81172b10",
  null
  
)

export default component.exports